import React from 'react';

import styles from './singleEntityDisplayStyles';

import Panel from 'buyside/components/presentation/Feed/CorporateAction/Panel/panel';
import RecentIdeaList from 'buyside/components/presentation/Feed/CorporateAction/RecentIdeaList/recentIdeaList';

import { entityUrl, assetUrl } from 'buyside/util/urlHelper';

const SingleEntityDisplay = ({
  parentEntity,
  parentAsset,
  parentPreActionPrice,
  parentPostActionPrice,
  parentActionPeriodReturn,
  timeframe = '30',
  currentUser
}) => {
  const name = parentAsset ? parentAsset.name : parentEntity.name;
  const url = parentAsset ? assetUrl(parentAsset.fsPermSecId) : entityUrl(parentEntity.id);
  const symbol = parentAsset ? parentAsset.symbol : parentEntity.primarySymbol;
  const recentIdeas = parentAsset ? parentAsset.recentIdeas : parentEntity.recentIdeas;

  return (
    <div className={styles.contentWrap}>
      <div>
        <RecentIdeaList ideas={recentIdeas} currentUser={currentUser} />
      </div>
      <div>
        <Panel
          header={name}
          headerUrl={url}
          symbol={symbol}
          tableData={[
            {
              label: `Price ${timeframe} days prior`,
              data: parentPreActionPrice
            },
            { label: 'Price 1 day prior', data: parentPostActionPrice },
            {
              label: `${timeframe}-day Trailing Return`,
              data: parentActionPeriodReturn,
              isReturn: true
            }
          ]}
        />
      </div>
    </div>
  );
};

export default SingleEntityDisplay;
